export default class SingleDiscountRequest {
    public discountId: string | undefined;
}   